import { Box, ButtonGroup, Flex, IconButton, Select, Td, Text } from '@chakra-ui/react';
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';


interface DefaultTablePaginationProps {
  count: number;
  page: number;
  setPage: (page: number) => void;
  rowsPerPage: number;
  setRowsPerPage?: (value: number) => void;
}

const DefaultTablePagination: React.FC<DefaultTablePaginationProps> = ({
  count,
  page,
  setPage,
  rowsPerPage,
  setRowsPerPage,
}) => {
  function handleChangeRowsPerPage(ev: React.ChangeEvent<HTMLSelectElement>) {
    const res = parseInt(ev.target.value, 10);
    if (!isNaN(res) && setRowsPerPage) {
      setRowsPerPage(res);
      setPage(1);
    }
  }

  const rangeStart = (page - 1) * rowsPerPage + 1;
  const rangeEnd = (page - 1) * rowsPerPage + rowsPerPage;

  return (
    <Td p={0} colSpan={1000} h="54px" textAlign="right">
      <Flex position="relative" align="center" fontSize={14} color="gray.600">
        <Box flex="1 1 100%" />
        <Text flexShrink={0} mr={4}>
          Rows per page:
        </Text>

        <Select
          mr={4}
          w="80px"
          fontSize={15}
          onChange={handleChangeRowsPerPage}
          defaultValue="25"
          variant="unstyled"
        >
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </Select>

        <Text flexShrink={0} mr={4}>{`${rangeStart} - ${
          rangeEnd > count ? count : rangeEnd
        } of ${count}`}</Text>

        <ButtonGroup mr={3}>
          <IconButton
            variant="ghost"
            colorScheme="gray"
            fontSize={22}
            icon={<MdChevronLeft />}
            isDisabled={page === 1}
            aria-label="previous"
            onClick={() => setPage(page - 1)}
          />

          <IconButton
            variant="ghost"
            colorScheme="gray"
            fontSize={22}
            icon={<MdChevronRight />}
            isDisabled={page * rowsPerPage > count}
            aria-label="next"
            onClick={() => setPage(page + 1)}
          />
        </ButtonGroup>
      </Flex>
    </Td>
  );
};

export default DefaultTablePagination;
